import type { ValueFormatterParams } from "ag-grid-community";

const unitAbbrev: Record<string, string> = {
  GALLON: "gal",
  GALLONS: "gal",
  LITER: "L",
  LITERS: "L",
  POUND: "lb",
  POUNDS: "lb",
  KILOGRAM: "kg",
  KILOGRAMS: "kg",
  GRAM: "g",
  GRAMS: "g",
};

export const volumeComparator = (a: any, b: any) => {
  const na = typeof a === "number" ? a : Number(a);
  const nb = typeof b === "number" ? b : Number(b);
  if (isNaN(na) && isNaN(nb)) {
    return 0;
  }
  if (isNaN(na)) {
    return -1;
  }
  if (isNaN(nb)) {
    return 1;
  }
  return na - nb;
};

export const VolumeCellRenderer = (params: ValueFormatterParams<number>) => {
  const value = (params.value as number) ?? null;
  const unitRaw = (params?.data as any)?.totalVolumeUnit as string | null;
  if (value == null || value === 0) {
    return "—";
  }
  const formatted = value.toLocaleString();
  const unit = unitRaw ? unitAbbrev[unitRaw] || unitRaw : undefined;
  return unit ? `${formatted} ${unit}` : formatted;
};
